import { HelperService } from '../utils/helper.service'

export default defineNuxtPlugin((nuxtApp) => {
    const helperService = new HelperService()
    nuxtApp.provide('helper', helperService)
})
